import _ from "lodash";
import { FORM_NAME, STATE_NAME } from "./forgotPin.constants";

export const getForgotPinFormValues = state =>
  _.get(state, `${FORM_NAME}.values`, {});

export const getError = state => state[STATE_NAME].error;
export const getSuccess = state => state[STATE_NAME].success || false;
